import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-pro";

export function DataGridToolBar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        printOptions={{
          disableToolbarButton: false,
          hideFooter: true,
          hideToolbar: true,
          fields: undefined, // include all exportable fields
        }}
        csvOptions={{
          allColumns: true, // include all visible columns that aren't marked disableExport
        }}
      />
    </GridToolbarContainer>
  );
}
